<template>
  <el-dialog
    :title="`删除${groupDetial.name}`"
    :visible.sync="visible"
    width="460px"
    append-to-body
    :before-close="done => (confirmLoading ? '' : done())"
  >
    <div class="group-del-modal" v-loading="initLoading">
      <span>该分组关联的</span>
      <span class="group-relation-field-count">{{ relationCount }}</span>
      <span>个标签，将全部修改关联分组为“以案件为单位”</span>
    </div>
    <span slot="footer">
      <el-button @click="visible = false">取 消</el-button>
      <el-button type="danger" :disabled="initLoading" :loading="confirmLoading" @click="confirmHandle()">
        <span>确定删除</span>
      </el-button>
    </span>
  </el-dialog>
</template>

<script setup>
import { errFunc } from '@/lib/utils';
import { services } from '@/service';
import { Message } from 'element-ui';
import { computed, onMounted, ref } from 'vue';

const emit = defineEmits(['update:show', 'success']);
const props = defineProps(['show', 'courseId', 'groupDetial']);

const visible = computed({
  get() {
    return props.show;
  },
  set(val) {
    emit('update:show', val);
  }
});

const initLoading = ref(true);
const relationCount = ref(0);
onMounted(async () => {
  try {
    const courseFields = await services.courseware.getFields(props.courseId);
    relationCount.value = courseFields.reduce((count, fieldDetail) => {
      if (fieldDetail.groupRelationId === props.groupDetial.id) {
        return count + 1;
      }
      return count;
    }, 0);
  } catch (err) {
    errFunc(err);
  } finally {
    initLoading.value = false;
  }
});

const confirmLoading = ref(false);
const confirmHandle = async () => {
  try {
    confirmLoading.value = true;

    await services.courseware.delCourseUnitGroup(props.groupDetial.id, props.courseId);

    Message.success('分组删除成功');
    emit('success');
    confirmLoading.value = false;
    visible.value = false;
  } catch (err) {
    errFunc(err);
  }
};
</script>

<style lang="scss" scoped>
.group-del-modal {
  color: #3d465a;
  font-size: 14px;
  line-height: 20px;
  min-height: 60px;
  .group-relation-field-count {
    color: #2c3443;
    margin: 0 3px;
  }
}
</style>
